import { Platform, createUseStyles } from 'core/src';
import React, { FC, memo } from 'react';
import { TextInput, StyleProp, ViewStyle, View } from 'react-native';

interface MyTextInputProps {
  placeholder?: string;
  placeholderTextColor?: string;
  inlineImageLeft?: any;
  type?: boolean;
  change?: (text: string) => void;
  value?: string;
  classes?: StyleProp<ViewStyle>;
  focus?: boolean;
  blur?: () => void;
  inputWidth?: any;
  inlineImageRight?: any;
  multiline?: boolean;
  onSubmit?: any;
  mxLength?: number;
}

const MyTextInput: FC<MyTextInputProps> = memo(
  ({
    placeholder,
    type,
    change,
    value,
    classes,
    focus,
    blur,
    inlineImageLeft,
    placeholderTextColor,
    inputWidth,
    inlineImageRight,
    multiline,
    onSubmit,
    mxLength,
  }) => {
    const { styles, colors } = useStyles();
    return (
      <View
        style={[
          { width: Platform.isDesktop ? inputWidth || '40%' : 'auto' },
          styles.inputContainer,
        ]}
      >
        {inlineImageLeft}
        <TextInput
          multiline={multiline}
          maxLength={mxLength}
          style={[styles.input, classes]}
          placeholder={placeholder}
          secureTextEntry={type}
          onChangeText={change}
          value={value}
          autoFocus={focus}
          underlineColorAndroid="transparent"
          onBlur={blur}
          onSubmitEditing={onSubmit}
          placeholderTextColor={
            placeholderTextColor ? placeholderTextColor : colors.primaryColor
          }
        />
        {inlineImageRight}
      </View>
    );
  },
);

const useStyles = createUseStyles(({ colors, theme }) => ({
  input: {
    marginHorizontal: 5,
    padding: 10,
    height: 40,
    backgroundColor: colors.secondryColor,
    borderRadius: 5,
    width: '90%',
    textAlign: 'left',
    color: colors.primaryColor,
    outline: 'none',
    borderColor: 'transparent',
    outlineStyle: 'none',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    justifyContent: 'space-between',
    borderColor: colors.secondryColorOpacity,
    borderRadius: 8,
    height: 43,
    paddingLeft: 10,
    paddingRight: 10,
  },
}));

export { MyTextInput };
